module.exports = __webpack_public_path__ + "assets/img/message.e490dde2.png";